import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

interface RouteErrorBoundaryState {
  error: Error | null;
}

export class RouteErrorBoundary extends Component<
  { children: ReactNode },
  RouteErrorBoundaryState
> {
  state: RouteErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): RouteErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Design Safety MY screen error", error, info);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <main className="fatal-error" role="alert">
        <div className="fatal-error-mark">
          <AlertTriangle size={34} />
        </div>
        <span className="eyebrow">Application recovery</span>
        <h1>This screen could not be displayed.</h1>
        <p>
          Your last saved records remain protected. Reload the application to return to the
          workspace.
        </p>
        <details>
          <summary>Technical detail</summary>
          <code>{this.state.error.message}</code>
        </details>
        <button className="button button-primary" type="button" onClick={() => window.location.reload()}>
          <RotateCcw size={17} />
          Reload application
        </button>
      </main>
    );
  }
}
